import styled, { CSSProperties } from "styled-components";

// TEXT

// STYLES
export const Flex = styled.div<Props>`
  display: flex;
  min-width: ${({ $minWidth }) => $minWidth};
  min-height: ${({ $minHeight }) => $minHeight};
  flex-flow: ${({ $flow = "row wrap" }) => $flow};
  flex-grow: ${({ $grow = "0" }) => $grow};
  gap: ${({ $gap = "1rem" }) => $gap};
  align-items: ${({ $align }) => $align};
  justify-content: ${({ $justify }) => $justify};
  justify-self: ${({ $justifySelf }) => $justifySelf};
  align-self: ${({ $alignSelf }) => $alignSelf};
  flex-wrap: ${({ $wrap }) => $wrap};
  width: ${({ $fullWidth }) => $fullWidth && "100%"};
  height: ${({ $fullHeight }) => $fullHeight && "100%"};
  flex-direction: ${({ $direction }) => $direction};
  flex: ${({ $flex }) => $flex};
`;

// DATA

// TYPES
type Props = {
  $flow?: CSSProperties["flexFlow"];
  $gap?: CSSProperties["gap"];
  $grow?: CSSProperties["flexGrow"];
  $align?: CSSProperties["alignItems"];
  $justify?: CSSProperties["justifyContent"];
  $justifySelf?: CSSProperties["justifySelf"];
  $alignSelf?: CSSProperties["alignSelf"];
  $minWidth?: CSSProperties["minHeight"];
  $minHeight?: CSSProperties["minHeight"];
  $wrap?: CSSProperties["flexWrap"];
  $fullWidth?: boolean;
  $fullHeight?: boolean;
  $direction?: CSSProperties["flexDirection"];
  $flex?: CSSProperties["flex"];
};

// CONSTANTS

// FUNCTIONS

// ASSETS
